import { jsx as _jsx } from "react/jsx-runtime";
import mapboxgl from 'mapbox-gl';
import { useEffect, useRef } from 'react';
import { useAppSelector } from '../../../../../application/store/useStore';
var ClientsToShowMap = function (_a) {
    var clients = _a.clients;
    var mapContainerRef = useRef(null);
    var mapboxAccessToken = useAppSelector(function (state) { return state.auth; }).mapboxAccessToken;
    useEffect(function () {
        var _a, _b;
        var map = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            accessToken: mapboxAccessToken,
            center: [(_a = clients[0]) === null || _a === void 0 ? void 0 : _a.longitude, (_b = clients[0]) === null || _b === void 0 ? void 0 : _b.latitude],
            zoom: 14
        });
        clients.forEach(function (client) {
            new mapboxgl.Marker().setLngLat([client.longitude, client.latitude]).addTo(map);
        });
        return function () { return map.remove(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clients, mapboxAccessToken]);
    return _jsx("div", { ref: mapContainerRef, style: { width: '100%', height: '100%' } });
};
export default ClientsToShowMap;
